import { Chip, IconButton, TableRow, TableRowColumn, TextField } from 'material-ui';
import React, { useState } from 'react';
import SaveIcon from 'material-ui/svg-icons/content/save';
import ContentAddIcon from 'material-ui/svg-icons/editor/mode-edit';

import { styles } from './FlagComplianceTable';
import FlagsComplianceAutoComplete from './FlagsComplianceAutoComplete';
import api from 'services';
import { addNotification } from 'actions/notifications/notifications';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const chipStyles = {
    chip: {
        margin: 4,
    },
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
    },
};

function FlagComplianceRow({ key, item, addNotification }) {
    const [riskFactor, setRiskFactor] = useState(item.riskFactor);
    const [avoid, setAvoid] = useState(item.compatibility);
    const [toUpdate, setToUpdate] = useState(false);
    const [showAdd, setShowAdd] = useState(false);

    const changeRiskFaktor = (value) => {
        setRiskFactor(value);
        setToUpdate(true);
    };

    const handleUpdate = async () => {
        const response = await api.updateFlagCompliance(
            item._id, { riskFactor: riskFactor || null, avoid: avoid.map(a => a._id) }
        );

        if (!response.errors.length) {
            addNotification({
                title: 'Success',
                message: 'Record updated successfully',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
            setToUpdate(false);
        } else {
            addNotification({
                title: 'Error',
                message: response.errors[0].message || response.errors[0].messages[0],
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
        }
    };

    const handleDeleteCountryChip = (countryId) => {
        setAvoid(avoid.filter(country => country._id !== countryId));
        setToUpdate(true);
    };

    const addToAvoid = (country) => {
        const includes = avoid.find(a => a._id === country._id);
        
        if (!includes) {
            setAvoid(avoid.concat(country));
            setToUpdate(true);
        }
    };

    return (
        <TableRow
            key={key}
        >
            <TableRowColumn
                style={styles.flag}
            >
                { item.flag }
            </TableRowColumn>
            <TableRowColumn
                style={styles.riskFactor}
            >
                <TextField 
                    name='riskFaktor'
                    value={riskFactor || ''}
                    onChange={e => changeRiskFaktor(e.target.value)}
                    style={{ fontSize: '14px' }}
                    type='number'
                />
            </TableRowColumn>
            <TableRowColumn
                style={styles.avoid}
            >
                <div className={showAdd ? '' : 'hidden'} >
                    <FlagsComplianceAutoComplete
                        addToAvoid={addToAvoid}
                    />

                </div>
                <div style={chipStyles.wrapper}>
                    { 
                        avoid.map((_avoid) => {
                            return renderChip(_avoid, handleDeleteCountryChip);
                        })
                    }
                </div>
            </TableRowColumn>
            <TableRowColumn
                style={styles.controls}
            >
                <div 
                    className={toUpdate ? '' : 'hidden'} 
                    style={{ textAlign: 'center', justifyContent: 'center' }}
                >
                    <IconButton>
                        <SaveIcon
                            onClick={handleUpdate}
                            style={{ margin: '70px 0 0 0' }}
                            color='#09BCD4'
                        />
                    </IconButton>
                </div>
                <IconButton
                    className={showAdd ? 'hidden' : ''}
                >
                    <ContentAddIcon
                        onClick={() => setShowAdd(!showAdd)}
                        style={{ margin: '70px 0 0 0' }}
                        color='#A6A6A6'
                    />
                </IconButton>
            </TableRowColumn>
        </TableRow>
    );
}

export default connect(
    (state) => {
        return {
            realCompaniesIds: state.realCompanies.items.map(c => c._id),
        };
    },
    dispatch => bindActionCreators({
        addNotification,
    },
    dispatch),
)(FlagComplianceRow);

function renderChip(item, handleDeleteCountry) {
    return (
        <Chip
            key={item._id}
            onRequestDelete={() => handleDeleteCountry(item._id)}
            style={chipStyles.chip}
        >
            {item.flag}
        </Chip>
    );
}



// WEBPACK FOOTER //
// ./app/components/FlagCompliance/FlagComplianceRow.jsx